import { Component, OnInit } from '@angular/core';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { Subscription } from 'rxjs';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { DetalleEstablecimientoService } from '../establecimiento/establecimiento.service';

@Component({
	selector: 'app-parafiscales-funcionario',
	templateUrl: './parafiscales-funcionario.component.html',
	styleUrls: ['./parafiscales-funcionario.component.scss']
})
export class ParafiscalesFuncionarioComponent implements OnInit {
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	suscripcion: Subscription;
	informacionEstablecimiento: any;
	constructor(private dataSharedService: DataSharedService, private detalleEstablecimientoService: DetalleEstablecimientoService) {
		this.suscripcion = this.dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
		});
		this.informacionEstablecimiento = {};
	}

	ngOnInit() {
		this.detalleEstablecimientoService.getDetalleEstablecimiento(this.datoSolicitudSharedModel.data).subscribe(res => {
			if (res.result) {
				this.informacionEstablecimiento = res.data;
			}
		});
	}
}
